<template>
  <div class="purchase-record">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="backClientManage">客户管理/</span>购买记录
      </template>
      <template v-slot:content>
        <div class="filter-custom-form-container" ref="formContainer">
          <el-form ref="filterClient" :model="filterClient" class="filter-customer-form">
            <div class="container">
              <el-form-item class="item" label="下单时间：" prop="createTime" style="width: 450px;">
                <el-date-picker
                  v-model="filterClient.createTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item class="item" label="商品名称：" prop="goodsName">
                <el-input
                  class="white"
                  clearable
                  v-model="filterClient.goodsName"
                  placeholder="请输入商品名称"
                ></el-input>
              </el-form-item>
              <el-form-item class="item" label="订单号：" prop="orderCode">
                <el-input
                  class="white"
                  clearable
                  v-model="filterClient.orderCode"
                  placeholder="请输入订单号"
                ></el-input>
              </el-form-item>
            </div>
            <div class="operations">
              <el-button class="btn-blue" @click="toFilterClient">筛选</el-button>
              <span class="reset-btn" @click="resetClientForm">清空筛选条件</span>
            </div>
          </el-form>
        </div>
        <div class="table">
          <el-table class="table-container" :data="tableList">
            <el-table-column label="商品名称" prop="goodsName" min-width="240" show-overflow-tooltip></el-table-column>
            <el-table-column label="数量" prop="nums" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="订单号" prop="orderCode" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="下单时间" prop="createTime" min-width="120" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <div class="pagination-tpl-container">
          <pagination-tpl
            class="pagination-tpl"
            :total="customerListTotal"
            :currentPage="currentPage"
            @queryChange="handleQueryChange"
          ></pagination-tpl>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import { formatTimeToDate } from "common/js/util";
import DBPurchase from "models/db/purchase";
export default {
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  },

  data() {
    return {
      filterClient: {
        createTime: null,
        goodsName: '',
        orderCode: ''
      },
      // 当前列表页
      currentPage: 1,
      // 客户总数
      customerListTotal: 0,
      tableList: [],
      userId: null
    }
  },

  created() {
    this.userId = Number(this.$route.query.userId)
    this.initList()
  },

  methods: {
    // 回到客户管理
    backClientManage() {
      this.$router.push({
        path: "/admin/client/client-manage-index/client-manage"
      });
    },
    initList() {
      let userId = this.userId
      let pageNo = this.currentPage
      let date = this.filterClient.createTime
      let goodsName = this.filterClient.goodsName
      let orderCode = this.filterClient.orderCode
      let beginDate = date? date[0]: ''
      let endDate = date? date[1]: ''
      let data = {
        pageNo,
        userId,
        goodsName,
        orderCode,
        beginDate,
        endDate
      }

      DBPurchase.getPurchaseRecordList(data).then(res => {
        if (res.success) {
          let { currentPage, totalNum, items } = res.result;
          this.currentPage = currentPage;
          this.customerListTotal = totalNum;
          let arr = []
          items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.goodsName = i.goodsName
            obj.createTime = i.orderTime?formatTimeToDate(i.orderTime):''
            obj.orderCode = i.orderCode
            obj.nums = i.quantity
            arr.push(obj)
          })
          this.tableList = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    handleQueryChange(query) {
      this.currentPage = query.currentPage;
      this.initList();
    },
    // 筛选客户
    toFilterClient() {
      // 将当前页面重置为初始页面
      this.currentPage = 1;
      this.initList();
    },
    // 清空客户筛选条件
    resetClientForm() {
      this.$refs.filterClient.resetFields();
      this.toFilterClient();
    },
  }
}
</script>

<style lang='scss'>
.purchase-record {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .filter-custom-form-container {
    width: 100%;
    box-sizing: border-box;
    margin: 16px 0 24px 0;
    padding: 22px 20px 26px 20px;
    background: rgba(245, 247, 250, 1);
    border-radius: 4px;
    .container {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      .item {
        margin-right: 24px;
      }
    }
    .operations {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 80px;
      .btn-blue {
        margin-right: 16px;
      }
      .reset-btn {
        cursor: pointer;
        font-size: 12px;
        color: rgba(61, 116, 242, 1);
        margin-left: 20px;
      }
    }
  }

  // 筛选客户form表单
  .filter-customer-form.el-form {
    .el-form-item {
      display: flex;
      .el-form-item__content {
        width: 160px;
      }
    }
  }
  .pagination-tpl-container {
    padding: 10px 24px 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
